<app-sidebar>
  <div class="container">
    <h1>{{ 'adminManagement' | translate }}</h1>
    <p class="subtitle">{{ 'adminManagementHint' | translate }}</p>

    <mat-card class="panel">
      <mat-form-field class="search-field" appearance="outline">
        <mat-label>{{ 'searchByNameOrEmail' | translate }}</mat-label>
        <mat-icon matPrefix class="search-icon">search</mat-icon>
        <input
          matInput
          [formControl]="searchControl"
          [matAutocomplete]="auto"
          placeholder="{{ 'typeToSearch' | translate }}"
        />
        <mat-autocomplete
          #auto="matAutocomplete"
          [displayWith]="displayFn"
          (optionSelected)="onSelect($event.option.value)"
        >
          <mat-option *ngFor="let user of users" [value]="user">
            <div class="user-option">
              <div class="avatar">{{ getInitials(user) }}</div>
              <div class="user-info">
                <span class="user-name">{{ user.name || user.username || '—' }}</span>
                <span class="user-email">{{ user.primaryEmail || '' }}</span>
              </div>
            </div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

      <div class="selected-user-card" *ngIf="selectedUser">
        <div class="avatar avatar--large">{{ getInitials(selectedUser) }}</div>
        <div class="selected-user-info">
          <span class="selected-name">{{ selectedUser.name || selectedUser.username }}</span>
          <span class="selected-email">{{ selectedUser.primaryEmail }}</span>
        </div>
        <button
          mat-raised-button
          color="primary"
          class="add-btn"
          (click)="addSuperadmin()"
          [disabled]="saving"
        >
          <mat-icon>add_moderator</mat-icon>
          {{ 'makeSuperadmin' | translate }}
        </button>
      </div>

      <app-invite-link></app-invite-link>
    </mat-card>

    <div class="admins-section">
      <h3 class="section-title">{{ 'currentSuperadmins' | translate }}</h3>

      <div class="loading-row" *ngIf="loading">
        <mat-spinner diameter="28"></mat-spinner>
      </div>

      <ng-container *ngIf="!loading">
        <div class="admin-list" *ngIf="superadmins.length; else noAdmins">
          <div class="admin-row" *ngFor="let row of superadmins">
            <div class="avatar">{{ getInitials(row.user) }}</div>
            <div class="user-info">
              <span class="user-name">
                {{ row.user?.name || row.user?.username || row.assignment.logtoUserId }}
              </span>
              <span class="user-email">
                {{ row.user?.primaryEmail || '(user not found in Logto)' }}
              </span>
            </div>
          </div>
        </div>

        <ng-template #noAdmins>
          <div class="empty-state">
            <mat-icon class="empty-icon">shield</mat-icon>
            <p>{{ 'noSuperadmins' | translate }}</p>
          </div>
        </ng-template>
      </ng-container>
    </div>
  </div>
</app-sidebar>
